import React from 'react';
import styled from 'styled-components';
import { items, preloader } from '../img';
import { NonReact } from '../dooh-react-utils';
import { activity } from 'dooh-utils';

export default function Game(props) {
  let [selected, setSelected] = React.useState(new Set());
  let startTime = React.useState(+new Date())[0];
  let pic = props.pic;
  let areas = [
    { w: 60, h: 90, x: 135, y: 800 },
    { w: 150, h: 100, x: 380, y: 1050 },
    { w: 140, h: 140, x: 500, y: 1250 },
    { w: 60, h: 60, x: 420, y: 830 },
    { w: 50, h: 50, x: 820, y: 940 },
    { w: 120, h: 120, x: 820, y: 750 },
  ];
  return (
    <Wrapper>
      <img
        className="main"
        src={preloader.get(items[pic])}
        alt=""
        draggable="false"
      />

      {areas.map((item, id) => (
        <Item
          key={id}
          {...item}
          selected={selected.has(id)}
          onClick={() => {
            activity();
            let s = new Set(selected);
            s.add(id);
            setSelected(s);
            if (s.size === 6) {
              let time = +new Date() - startTime;
              setTimeout(() => props.update({ screen: 'result', time }), 1000);
            }
          }}
        />
      ))}

      {areas.map((item, id) => (
        <Item
          key={id}
          {...item}
          y={item.y - 720}
          selected={selected.has(id)}
          onClick={() => {
            activity();
            let s = new Set(selected);
            s.add(id);
            setSelected(s);
            if (s.size === 6) {
              let time = +new Date() - startTime;
              setTimeout(() => props.update({ screen: 'result', time }), 1000);
            }
          }}
        />
      ))}

      <NonReact
        delegate={Timer}
        time={startTime}
        stop={selected.size === 6}
        onClick={props.gotoFirstScreen}
        onTimeout={() => {
          props.update({ screen: 'intro', time: +new Date() - startTime });
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: url('${() =>
    preloader.get(require('../img/game.png'))}') no-repeat 0 0;
  width: 1080px;
  height: 1920px;

  img.main {
    position: absolute;
    top: 225px;
  }

  .NonReact {
    bottom: 90px;
    position: absolute;
    left: 450px;
    display: block;
    width: 180px;
    text-align: center;
    font-size: 50px;
    text-transform: uppercase;
    background: rgba(1,1,1,0);

    small {
      display: block;
      font-size: 30px;
    }
  }
`;

// min dim 100x100 when selected
const Item = styled.div`
  position: absolute;
  width: ${p => (p.selected ? Math.max(p.w, 100) : p.w)}px;
  height: ${p => (p.selected ? Math.max(p.h, 100) : p.h)}px;
  left: ${p => p.x - (p.selected && p.w < 100 ? (100 - p.w) / 2 : 0)}px;
  top: ${p => p.y + 225 - (p.selected && p.h < 100 ? (100 - p.h) / 2 : 0)}px;
  background: url('${() =>
    preloader.get(require('../img/krug.png'))}') no-repeat 50% 50%;
  opacity: ${p => (p.selected ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
`;

class Timer {
  create(el, props) {
    this.time = props.time;
    this.onTimeout = props.onTimeout;
    this.interval = setInterval(this.updateTime, 200);
    el.addEventListener('click', props.onClick);
    this.el = el;
  }

  update(el, props) {
    if (props.stop) clearInterval(this.interval);
  }

  destroy() {
    clearInterval(this.interval);
  }

  updateTime = () => {
    let t = 3 * 60 - Math.round((+new Date() - this.time) / 1000);
    if (t <= 0) {
      t = 0;
      clearInterval(this.interval);
      this.onTimeout();
    }
    let m = Math.floor(t / 60);
    let s = t % 60;
    this.el.innerHTML = `${m}:${s <= 9 ? '0' : ''}${s}<small>vrijeme</small>`;
  };
}
